var fn = function( obj ){
var __t,__p='';
__p+='// FragColor.a *= 0.4 + smoothstep(0.2, 0.6, ) * 0.4;\nFragColor.rgb = vec3(0., 0., 0.);\nFragColor.rgb = baseColor();\nFragColor.a = alpha();\n\nif(FragColor.a == .0) discard;\n\nFragColor.rgb *= mix(vec3(1.,0.96,0.9), vec3(0.97, 0.97, 0.97), smoothstep(0.0, 0.4, localPosition.y)) * 1.4;\n// FragColor.rgb = vec3(1.0, 1.0, 1.0) * 1.3;\n';
return __p;
};
fn.toString=fn;
module.exports = fn;